import ImageData from './Image';

/* eslint-disable camelcase */
class NewsData {
  constructor({ attributes: { hero_image_1, hero_image_2 } }) {
    if (!hero_image_1 || !hero_image_2) {
      return;
    }

    this.heroImage1 = new ImageData(hero_image_1?.data);
    this.heroImage2 = new ImageData(hero_image_2?.data);
  }
}

export default NewsData;
